import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { ClientCollection, RouteHttpVerb, AbstractPostCollection } from "@devowl-wp/utils";
import { request } from "../utils";
import { BlockerModel } from ".";
import { computed } from "mobx";
class BlockerCollection extends AbstractPostCollection {
    constructor(store){
        super();
        this.store = store;
    }
    get sortedBlockers() {
        const result = Array.from(this.entries.values());
        result.sort((a, b)=>{
            if (a.data.menu_order < b.data.menu_order) {
                return -1;
            } else if (a.data.menu_order > b.data.menu_order) {
                return 1;
            } else {
                // a.menu_order === b.menu_order
                if (a.key < b.key) {
                    return 1;
                } else if (a.key > b.key) {
                    return -1;
                } else {
                    return 0;
                }
            }
        });
        return result;
    }
    instance(response) {
        return new BlockerModel(this).fromResponse(response);
    }
}
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], BlockerCollection.prototype, "sortedBlockers", null);
BlockerCollection = _ts_decorate([
    ClientCollection.annotate({
        path: "/rcb-blocker",
        singlePath: "/rcb-blocker/:id",
        namespace: "wp/v2",
        methods: [
            RouteHttpVerb.GET
        ],
        request
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof CookieStore === "undefined" ? Object : CookieStore
    ])
], BlockerCollection);
export { BlockerCollection };
